module.exports = __webpack_public_path__ + "img/manual_asnwer.7fce09f5.png";